import { TDeviceType, UIHeading2 } from '@cian/ui-kit';
import { clsx as cn } from 'clsx';
import * as React from 'react';

import * as styles from './Prefooter.css';
import { NBSP } from '../../constants/symbols';
import { Section } from '../Section';

interface IMakeMoneyProps {
  deviceType: TDeviceType;
  action: React.ReactNode;
}

export const Prefooter: React.FC<IMakeMoneyProps> = ({ action, deviceType }) => (
  <Section deviceType={deviceType}>
    <div className={cn(styles['container'], styles[`container-${deviceType}`])}>
      <div className={cn(styles['text-wrapper'], styles[`text-wrapper-${deviceType}`])}>
        <UIHeading2 color="white_100">
          Присоединяйтесь к{NBSP}программе клиентского вознаграждения и зарабатывайте с Циан
        </UIHeading2>
      </div>
      <div className={styles['action-wrapper']}>{action}</div>
    </div>
  </Section>
);
